import React from 'react';
import '../../styles/style.css';

const Short_Effective = () => (
  <div className="container">
    <div className="Short_Effective">
      {/*<h1>Short & Effective Sunbound Villas Slogan Will go at this Place Here!</h1>*/}
      <h1>Sun, Sea, Serenity.</h1>
    </div>
  </div>
);

export default Short_Effective;